import React from "react";
// reactstrap components
import {Breadcrumb,BreadcrumbItem,Container,Row,Col} from "reactstrap";

import { Link } from 'react-router-dom';

class TimelineHeader extends React.Component {

  constructor(props){

    super(props);

    window.simpleHead = this;

  }

  render() {

    var className;
    
    if(this.props.cl !== undefined){

      className = this.props.cl;
      
    }else{

      className = "header header-dark bg-info pb-6 content__title content__title--calendar";

    }

    return (
      <React.Fragment>
        <div cltop="1" className={className}>
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="8" xs="7">
                  <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0">{this.props.name}</h6>
                  <Breadcrumb className="d-none d-md-inline-block ml-lg-4" listClassName="breadcrumb-links breadcrumb-dark">
                    <BreadcrumbItem><Link to="/"><i className="fas fa-home" /></Link></BreadcrumbItem>
                    { this.props.way.map((value,index)=>{ return(<BreadcrumbItem key={index}><Link to={value.url} >{value.name}</Link></BreadcrumbItem>) }) }
                  </Breadcrumb>
                </Col>
                <Col className="mt-3 mt-md-0 text-md-right" lg="4" xs="5">{this.props.buttons}</Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default TimelineHeader;
